module.exports = __webpack_public_path__ + "img/CATEGORY ICON-30.f2ef95ec.png";